"use client"

function TaskCard({ task, onMove, onEdit, showEditButton }) {
  // Get next status for task movement
  const getNextStatus = (currentStatus) => {
    switch (currentStatus) {
      case "Pending":
        return "Working"
      case "Working":
        return "Completed"
      default:
        return null
    }
  }

  // Get button text based on next status
  const getButtonText = (nextStatus) => {
    switch (nextStatus) {
      case "Working":
        return "Start Working"
      case "Completed":
        return "Mark Completed"
      default:
        return ""
    }
  }

  const nextStatus = getNextStatus(task.status)

  return (
    <div className="task-card">
      <div className="task-header">
        <h4>{task.name}</h4>
        {showEditButton && onEdit && (
          <button onClick={() => onEdit(task)} className="edit-btn">
            <img
              src="https://cdn-icons-png.flaticon.com/512/1159/1159633.png" 
              alt="Edit"
              style={{ width: "20px", height: "20px", filter: "invert(21%) sepia(93%) saturate(7467%) hue-rotate(0deg) brightness(97%) contrast(114%)"}}
            />
          </button>
        )}
      </div>

      <div className="task-details">
        <div style={{display:"inline-flex"}}><h4 className="task-heading" style={{ marginRight: "8px" }}>Start:</h4><span style={{color: "#c4d6ef"}}>{task.startDate}</span></div>
        <div style={{display:"inline-flex"}}><h4 className="task-heading" style={{ marginRight: "8px" }}>Type:</h4> <span style={{color: "#c4d6ef"}}>{task.taskType}</span></div>
        <div style={{display:"inline-flex"}}><h4 className="task-heading" style={{ marginRight: "8px" }}>Project:</h4><span style={{color: "#c4d6ef"}}>{task.project}</span></div>
        <div className="task-description"><h4 className="task-heading">Description:</h4>{task.description}</div>
      </div>
    <div className="btn-task">
      {nextStatus && onMove && (
        <button onClick={() => onMove(task.id, nextStatus)} className="btn-primary">
          {getButtonText(nextStatus)}
        </button>
      )}
    </div>
    </div>
  )
}

export default TaskCard
